// extracted by mini-css-extract-plugin
export default {"frame":"BlockedEmbed_frame__G4V0a","icon":"BlockedEmbed_icon__d0FqR","actions":"BlockedEmbed_actions__gsA+9"};